import { render } from "./B2bPageInventoryReport.vue?vue&type=template&id=3b2e87ef&scoped=true&lang=pug"
import script from "./B2bPageInventoryReport.vue?vue&type=script&lang=js"
export * from "./B2bPageInventoryReport.vue?vue&type=script&lang=js"

import "./B2bPageInventoryReport.vue?vue&type=style&index=0&id=3b2e87ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2e87ef"]])

export default __exports__